/* ==========================================================================
   Cambie B2B Wholesale Landing — behaviour
   Shopify: upload as assets/cambie-b2b.js
   Load with: <script src="{{ 'cambie-b2b.js' | asset_url }}" defer></script>
   No dependencies. Safe to run more than once (Shopify section reloads).
   ========================================================================== */
(function () {
  'use strict';

  /* --- Mobile nav ------------------------------------------------------- */
  function initNav(root) {
    var toggle = root.querySelector('[data-nav-toggle]');
    var nav = root.querySelector('[data-nav]');
    if (!toggle || !nav || toggle.dataset.bound) return;
    toggle.dataset.bound = '1';

    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });

    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* --- FAQ: one open at a time (remove if you want them independent) ----- */
  function initFaq(root) {
    var items = root.querySelectorAll('[data-faq] .faq__item');
    items.forEach(function (item) {
      if (item.dataset.bound) return;
      item.dataset.bound = '1';
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  }

  /* --- Lazy autoplay for the hero / gallery videos ----------------------- */
  /* Videos start paused; they play only while on screen, which keeps the
     Shopify page from paying for decode on load. */
  function initVideos(root) {
    var videos = root.querySelectorAll('video[data-autoplay]');
    if (!videos.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });

    videos.forEach(function (v) {
      if (v.dataset.bound) return;
      v.dataset.bound = '1';
      v.muted = true;
      v.playsInline = true;
      io.observe(v);
      v.closest('.media') && v.closest('.media').classList.add('is-filled');
    });
  }

  /* --- Mark filled media so placeholder labels disappear ----------------- */
  function initMedia(root) {
    root.querySelectorAll('.media').forEach(function (m) {
      if (m.querySelector('img, video, iframe')) m.classList.add('is-filled');
    });
  }

  /* --- Sticky-header-aware anchor scrolling ------------------------------ */
  function initAnchors(root) {
    var header = root.querySelector('.header');
    if (!header) return;
    root.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - header.offsetHeight - 8;
      window.scrollTo({ top: top, behavior: 'smooth' });
      history.replaceState(null, '', id);
    });
  }

  function init(root) {
    root = root || document;
    initNav(root);
    initFaq(root);
    initMedia(root);
    initVideos(root);
    initAnchors(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Shopify theme editor: re-init when a section is redrawn. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.CambieB2B = { init: init };
})();

window.addEventListener("scroll", function () {
    const scrolledFromTop = window.scrollY > 0;

    document.querySelectorAll(".needsclick").forEach(function (element) {
        element.classList.toggle("hidden", scrolledFromTop);
    });
});